/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/UIContributions/AzureRMEndpoint/Components/Common/ValidatedTextField" />
import React = require("react");
import { ActionCreatorManager } from "DistributedTask/Flux/ActionCreatorManager";
import { InputValidationActionCreator } from "DistributedTaskUI/ServiceEndpoints/Editor/Actions/InputValidationActionCreator";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ITextFieldProps, TextField } from "VSSUI/TextField";
import { IValidationProps } from "./IValidationProps";
import { InputDetails } from "DistributedTaskUI/ServiceEndpoints/Editor/Components/EndpointsEditorPanelInterfaces";

export interface IValidatedTextFieldProps extends ITextFieldProps, IValidationProps {
    validationDetails: InputDetails;
}

export class ValidatedTextField extends VssComponent<IValidatedTextFieldProps> {

    private readonly _validationActionCreator: InputValidationActionCreator;

    constructor(props: IValidatedTextFieldProps, context: IVssComponentContext) {
        super(props, context);

        this._validationActionCreator = ActionCreatorManager.CreateActionCreator<InputValidationActionCreator, IVssPageContext>(InputValidationActionCreator, this.props.validationScopeId, context.pageContext);
    }

    public componentDidMount(): void {
        setTimeout(() => this._validationActionCreator.addInputs([this.props.validationDetails]));
    }

    public componentWillUnmount(): void {
        setTimeout(() => this._validationActionCreator.removeInputs([this.props.validationDetails.inputId]));
    }

    public render(): React.ReactNode {
        return (<TextField {...this.props} onChange={this._onChange} />);
    }

    private _onChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string): void => {
        this._validationActionCreator.validateInputState(this.props.validationDetails.inputId, value, false);

        if (this.props.onChange) {
            this.props.onChange(event, value);
        }
    }
}
